<section class="">
  <div class="clearfix title-holder has-btn">
    <div class="d-flex align-items-center gap-3 mb-3">
      <div class="d-flex align-items-center gap-2">
        <h6 class="mb-0 page-title" i18n>Reviews to Write</h6>
        <app-page-help articleId="v1ZFtAp9KDaYNxmauTv4kS" videoId="-"></app-page-help>

        <ul class="internal-module-switcher ml-3">
          <li
            class="module-item"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            matTooltip="Dashboard"
            i18n-matTooltip
          >
            <a routerLink="/reviews">
              <i class="cs-icon cs-icon-dashboard2 text-xl"></i>
            </a>
          </li>
          <li class="module-item" routerLinkActive="active" matTooltip="Reviews" i18n-matTooltip>
            <a routerLink="/reviews/list">
              <i class="cs-icon cs-icon-chat-star2 text-xl"></i>
            </a>
          </li>
          <li class="module-item" routerLinkActive="active" matTooltip="Bookings" i18n-matTooltip>
            <a routerLink="/reviews/bookings">
              <i class="cs-icon cs-icon-calendar-alt text-xl"></i>
            </a>
          </li>
        </ul>
      </div>
      <div class="flex-fill"></div>
      <ng-template [ngTemplateOutlet]="automationBtn"></ng-template>
    </div>
  </div>
  <div class="container-box">
    <!-- input fields -->
    <div class="filters-box">
      <app-rental-select
        [inline]="true"
        [ctrl]="filtersForm.get('rentals')"
        placeholder="Rental"
        i18n-matTooltip
        i18n-placeholder
        matTooltip="Only show reviews with the selected rental."
      ></app-rental-select>
      <app-select-search
        bindValue="value"
        bindLabel="name"
        [items]="sourceOptions"
        [ctrl]="filtersForm.get('sources')"
        placeholder="Channel"
        i18n-matTooltip
        i18n-placeholder
        matTooltip="Only show reviews with the selected channel."
      ></app-select-search>
      <app-cancel-filters
        [isFiltering]="filtersForm | isFiltering"
        [filterControl]="filtersForm"
        [searchCom]="searchCom"
      ></app-cancel-filters>
      <button
        class="btn btn-secondary-primary"
        (click)="onRefresh()"
        i18n-matTooltip
        matTooltip="Refresh List"
        matTooltipPosition="above"
      >
        <i class="far fa-sync"></i>
      </button>
      <div class="flex-fill"></div>
      <app-table-search (search)="onSearch($event)" #searchCom></app-table-search>
    </div>
    <div class="table-holder table-responsive">
      <table class="table table-default table-striped">
        <mat-table #table [dataSource]="dataSource" multiTemplateDataRows>
          <ng-container matColumnDef="reviewee.name">
            <mat-header-cell *matHeaderCellDef> <ng-container i18n>Reviewee</ng-container></mat-header-cell>
            <mat-cell *matCellDef="let element" class="gap-2 py-2">
              <app-rental-image [rentalId]="element.rentalId" [circle]="true" [clickable]="true"></app-rental-image>
              <div>
                <app-rental-name
                  [rentalId]="element.rentalId"
                  [clickable]="true"
                  class="text-semi-bold text-link"
                ></app-rental-name>
                <div
                  class="text-truncate text-link text-sm"
                  *ngIf="guestsById[element.guestId] as guest; else reviewee"
                  [matTooltip]="guest?.name"
                  (click)="onGuest(element.guestId)"
                  style="opacity: 0.7"
                >
                  {{ guest?.name }}
                </div>
                <ng-template #reviewee>
                  <div
                    class="text-truncate text-link text-sm"
                    *ngIf="element.reviewee as reviewee"
                    [matTooltip]="reviewee?.name"
                    style="opacity: 0.7"
                  >
                    {{ reviewee?.name }}
                  </div>
                </ng-template>

                <div
                  class="text-truncate text-link text-sm"
                  (click)="onBooking(element.inquiryId)"
                  *ngIf="element.checkIn"
                  style="opacity: 0.7"
                >
                  {{ element.checkIn | epochUTC : 'MMM DD, YYYY' }} -
                  {{ element.checkOut | epochUTC : 'MMM DD, YYYY' }}
                </div>
              </div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="reviewerCanSubmitUntil">
            <mat-header-cell *matHeaderCellDef> <ng-container i18n>Expired At</ng-container></mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.reviewerCanSubmitUntil | date : 'dd - MMM - yyyy HH:mm' }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="reservationId">
            <mat-header-cell *matHeaderCellDef> <ng-container i18n>Reservation #</ng-container></mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.reservationId }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="source">
            <mat-header-cell *matHeaderCellDef> <ng-container i18n>Channels</ng-container></mat-header-cell>
            <mat-cell *matCellDef="let element">
              <img [src]="element.source | channelIcon : false" [alt]="element.source" height="25" />
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="edit">
            <mat-header-cell *matHeaderCellDef> <ng-container i18n>Edit</ng-container> </mat-header-cell>
            <mat-cell *matCellDef="let element" class="">
              <div dropdown placement="bottom right" container="body" [isDisabled]="1 | isReadonlyRole">
                <div dropdownToggle (click)="$event.stopPropagation()" class="btn-group btn-ellips-holder">
                  <a class="btn-ellips">
                    <i class="fas fa-ellipsis-v"></i>
                  </a>
                </div>
                <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
                  <li
                    i18n-matTooltip
                    matTooltip="Add review manually"
                    matTooltipPosition="left"
                    *ngIf="isGuestReviewable | call : element"
                  >
                    <button (click)="onReview(element)" type="button">
                      <i class="fas fa-star-half-alt"></i><ng-container i18n>Add Review</ng-container>
                    </button>
                  </li>
                  <li i18n-matTooltip matTooltip="Assign booking rating for automated review" matTooltipPosition="left">
                    <button (click)="onRateBooking(element)" type="button">
                      <i class="far fa-calendar-star"></i><ng-container i18n>Rate Booking</ng-container>
                    </button>
                  </li>
                </ul>
              </div>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>

        <mat-paginator2
          #paginator
          [length]="totalCount"
          [class.hidden]="isEmpty$ | async"
          [pageSize]="10"
          [pageSizeOptions]="[5, 10, 20, 50, 75, 100]"
          (page)="onPageChange($event)"
          [showFirstLastButtons]="true"
        >
        </mat-paginator2>

        <app-empty-table
          *ngIf="isEmpty$ | async"
          [isFiltering]="(filtersForm | isFiltering) || !searchCom.isEmpty"
          type="ReviewBookings"
        ></app-empty-table>
      </table>
    </div>
  </div>

  <!-- /End Shared Content page -->
</section>

<ng-template #automationBtn>
  <button
    (click)="onAddAutomation()"
    [disabled]="1 | isReadonlyRole"
    class="btn btn-secondary-info"
    i18n-matTooltip
    matTooltip="Define rules to create your reviews automatically"
  >
    <span class="cs-icon cs-icon-automations"></span>
    <ng-container i18n>Automation</ng-container>
  </button>
</ng-template>

<ng-template #addBtn>
  <button
    (click)="onAddChannel()"
    [disabled]="1 | isReadonlyRole"
    class="btn btn-secondary-info"
    matTooltip="Manually create a channel"
  >
    <span class="cs-icon cs-icon-plug"></span>
    <ng-container i18n>Connect Channel</ng-container>
  </button>
</ng-template>
